// This script appends the 'gclid' query parameter to all anchor links with the attribute 'data-append-utm="true"' if the 'gclid' parameter is present in the current page's URL.
const applyLinks = document.querySelectorAll<HTMLAnchorElement>('a[data-append-utm="true"]');

if (applyLinks.length > 0) {
  const gclid = new URLSearchParams(window.location.search).get('gclid');

  if (gclid) {
    applyLinks.forEach((link) => {
      const url = new URL(link.href);
      url.searchParams.set('gclid', gclid);
      link.setAttribute('href', url.toString());
    });
  }
}
